<template>
    <v-col class="py-0 pt-2">
        <div class="d-flex">
            <v-icon color="black" class="mr-2">mdi-bank</v-icon>
            <p class="subtitle-2 mt-1 mb-0">Bank Name</p>
        </div>
        <div class="d-flex justify-space-between">
            <div class="d-flex">
                <p class="subtitle-1 mb-0 font-weight-bold d-inline-block text-truncate ellipsis">
                    {{ bankName }}
                </p>
                <v-tooltip bottom v-if="$vuetify.breakpoint.smAndDown">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            size="16"
                        >
                            mdi-information-outline
                        </v-icon>
                    </template>
                    <span>{{ bankName }}</span>
                </v-tooltip>
            </div>

            <v-btn
                absolute
                @click="copyToClipboard(bankName)"
                x-small
                class="warning copy-button"
            >
                Copy
            </v-btn>
        </div>
    </v-col>
</template>

<script>
    export default {
        name: "match-confirmed-field-bank-name",
        props: {
            recipientInfo: Object
        },
        computed: {
            bankName() {
                const { bank_name: bankName } = this.recipientInfo;

                if (!bankName) {
                    return '';
                }

                const bankNameLowerCase = bankName.toLowerCase().replace(/\s+/g, ' ');

                if(bankNameLowerCase.indexOf('first city monument bank') >= 0) {
                    return 'First City Monument Bank (FCMB)';
                }

                if(bankNameLowerCase.indexOf('guaranty trust bank') >= 0) {
                    return 'Guaranty Trust Bank (GTBank)';
                }

                if(bankNameLowerCase.indexOf('united bank of africa') >= 0) {
                    return 'United Bank of Africa (UBA)';
                }

                return bankName;
            }
        }
    }
</script>

<style scoped>
    .v-tooltip__content.menuable__content__active {
        background: #333333;
        opacity: 1 !important;
    }
</style>
